import React, { FC } from "react";

import { OnboardingProps } from "../../models";
import { CustomizeStepProps, CustomizeStep } from "components/Onboarding/components/V3/CustomizeStep";

export interface CustomizeStepContainerProps extends Pick<CustomizeStepProps, "aside" | "style" | "className"> {
    initialProps: OnboardingProps;

    onNext(props: OnboardingProps): void;
    onBack?(): void;
}

export const CustomizeStepContainer: FC<CustomizeStepContainerProps> = (props) => {
    const { initialProps, onNext, onBack, ...rest } = props;

    const handleCustomize = (value: OnboardingProps) => {
        onNext(value);
    };

    return <CustomizeStep {...rest} aside={props.aside} onboarding={initialProps} onCustomize={handleCustomize} />;
};
